<script setup lang="ts">
import { messageBoxContent, showMessageBox, messageType } from "./messageBox";
import Close from "@/components/global/Close/Close.vue";
import { ref, watch } from "vue";
import { setStorage } from "@/utils/storage";

const announcementTips = ref(false);

const closeBox = () => {
  showMessageBox.value = false;
};

const cancelBox = () => {
  closeBox();
  messageBoxContent.value.cancel && messageBoxContent.value.cancel();
};

const confirm = () => {
  messageBoxContent.value.confirm && messageBoxContent.value.confirm();
};

watch(announcementTips, () => {
  setStorage("announcementTips", announcementTips.value ? "1" : "0");
});
</script>

<template>
  <div class="csdMessageBox">
    <div class="msg_header" flex items-center>
      <img :src="`/images/info.png`" class="!size-20" />
      <span class="msg_title text-#202123" font-bold inline-block ml-8>{{
        messageBoxContent.title || "提示"
      }}</span>
      <Close
        :hover-color="`#E0E0E0`"
        color="#959595"
        style="margin-top: -8px; margin-right: -8px"
        @click="closeBox"
      ></Close>
    </div>
    <div class="msg_content" py-25 text="#202123" whitespace-pre-wrap break-all>
      <span
        v-if="messageBoxContent.content_type === 'html'"
        v-html="messageBoxContent.content"
        whitespace-pre-wrap
        break-all
        leading-22
      ></span>
      <span
        v-else
        class="text-#202123"
        whitespace-pre-wrap
        break-all
        leading-22
        >{{ messageBoxContent.content || "" }}</span
      >
    </div>
    <div v-if="messageType == 'announcement'" flex-align flex-row-reverse mb-10>
      不再提示
      <el-switch v-model="announcementTips" mr-10 />
    </div>
    <div class="bottom_btn" max-w-100 flex items-center justify-center>
      <div class="btn_content" flex>
        <div
          class="btn close"
          px-30
          py-9
          rounded-4
          bg="#E9EBEF"
          text="#161718"
          cursor-pointer
          @click="cancelBox"
        >
          {{ messageBoxContent.cancelText || "取消" }}
        </div>
        <div
          class="btn confirm"
          px-30
          py-9
          ml-16
          rounded-4
          bg="#4C83FC"
          text="#FFFFFF"
          hover:opacity-80
          cursor-pointer
          @click="confirm"
        >
          {{ messageBoxContent.confirmText || "确认" }}
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.csdMessageBox {
  padding: 15px 15px 27px;
}
</style>
